import { render, staticRenderFns } from "./MainMotorTemperature.vue?vue&type=template&id=408b4738&scoped=true&"
import script from "./MainMotorTemperature.vue?vue&type=script&lang=ts&"
export * from "./MainMotorTemperature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408b4738",
  null
  
)

export default component.exports